exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-label {\n  top: unset !important;\n  bottom: 50px !important;\n}\n\n.labels-title {\n  text-align: center;\n  font-weight: bold;\n}\n\n.modal-labels {\n  padding: 0;\n}\n\n.label-item {\n  list-style: none;\n  text-align: center;\n  font-size: 20px;\n}\n\n@media (max-width: 479px) {\n  .modal-dialog {\n    margin-top: 80px;\n    max-height: 80vh;\n  }\n\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/layouts/widgets/mobile-menu/mobile-menu.component.css
// module id = ../../../../../src/app/layouts/widgets/mobile-menu/mobile-menu.component.css
// module chunks = main